import * as Yup from 'yup';

export const activityPlanEventDetailInitialValues = (eventDetail) => {
  return {
    eventDetail: eventDetail ? eventDetail : '',
  };
};

export const activityPlanDetailValidationSchema = (t) => Yup.object().shape({
  eventDetail: Yup.string().required(t('formulary.validation.select_activity_type_required')),
});
